import * as React from 'react';

import { BaseComponent } from '../BaseComponent';
import { DebugActions } from '../../actions/DebugActions';
import { RELEASE_VERSION } from '../../App';

interface HamburgerFooterProps {
    userLanguage: string;
}

interface HamburgerFooterState {
    blockContent: boolean;
}

export class HamburgerFooter extends BaseComponent<HamburgerFooterProps, HamburgerFooterState> {
    protected mainLinkNode: HTMLDivElement;
    public componentWillMount(): void {
        this.setState({blockContent: false});
    }

    public componentDidMount(): void {
        if (
            this.mainLinkNode &&
            this.mainLinkNode.scrollWidth > this.mainLinkNode.clientWidth &&
            !this.state.blockContent
        ) {
            this.setState({blockContent: true});
        }
    }

    public componentDidUpdate(): void {
        if (
            this.mainLinkNode &&
            this.mainLinkNode.scrollWidth > this.mainLinkNode.clientWidth &&
            !this.state.blockContent
        ) {
            this.setState({blockContent: true});
        }
    }

    public render(): JSX.Element | null {
        if (RELEASE_VERSION) {
            return (
                <div className="core-footer">
                    <div className="core-footer-group core-footer-version" onClick={DebugActions.knock}>{'Version: ' + RELEASE_VERSION.toString()}</div>
                </div>
            );
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/HamburgerFooter.tsx